export default [
  'กรง',
  'กรอบ',
  'กระถาง',
  'กระบอก',
  'กระป๋อง',
  'กระสอบ',
  'กรัม',
  'กล่อง',
  'ก้อน',
  'กิโลกรัม',
  'ขด',
  'ขวด',
  'คัน',
  'คิว',
  'เครื่อง',
  'งาน',
  'ชิ้น',
  'ชุด',
  'ซอง',
  'เซนติเมตร',
  'ตลับ',
  'ตัน',
  'ตัว',
  'ตารางนิ้ว',
  'ตารางฟุต',
  'ตารางเมตร',
  'ตู้',
  'ถ้วย',
  'ถัง',
  'ถุง',
  'ท่อน',
  'แท่ง',
  'นิ้ว',
  'บาน',
  'ใบ',
  'ปี๊บ',
  'ผืน',
  'แผง',
  'แผ่น',
  'พาเลท',
  'แพค/ห่อ',
  'ฟุต',
  'แฟ้ม',
  'ภาพ/รูป',
  'ม้วน (Roll)',
  'มัด',
  'มิลลิกรัม',
  'มิลลิเมตร',
  'มิลลิลิตร',
  'เม็ด',
  'เมตร',
  'รีม',
  'เรือน',
  'ล้อ',
  'ลัง',
  'ลิตร',
  'ลูก',
  'ลูกบาศก์เซนติเมตร',
  'ลูกบาศก์เดซิเมตร',
  'ลูกบาศก์นิ้ว',
  'ลูกบาศก์ฟุต',
  'ลูกบาศก์เมตร',
  'เล่ม',
  'วง',
  'เส้น',
  'หน่วย',
  'หลอด',
  'หลัง',
  'หลา',
  'หีบ',
  'โหล',
  'ออนซ์',
];
